import { useTranslation } from 'react-i18next';
import {
	CompanyRelationship,
	getRelationshipBadgeClasses,
	getRelationshipLabel,
} from '@/utils/companyRelationship';

interface CompanyRelationshipBadgeProps {
	relationship?: CompanyRelationship | null;
	size?: 'xs' | 'sm';
	showNone?: boolean;
}

export const CompanyRelationshipBadge = ({
	relationship,
	size = 'xs',
	showNone = false,
}: CompanyRelationshipBadgeProps) => {
	const { t } = useTranslation();
	if (!relationship || (relationship === 'none' && !showNone)) return null;

	const padding = size === 'xs' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs';

	return (
		<span
			className={`inline-flex items-center rounded-sm font-medium ${padding} ${getRelationshipBadgeClasses(relationship)}`}
		>
			{getRelationshipLabel(relationship, t)}
		</span>
	);
};
